import { Endpoint } from "../config";

export type PermissionEndpointType =
  | "permissionsList"
  | "permissionProfile"
  | "permissionProfileById"
  | "assignProfileUserList"
  | "staffEditAssignProfile";

export const permissionEndpoints: Record<PermissionEndpointType, Endpoint> = {
  permissionsList: {
    url: "permission-list/",
  },
  permissionProfile: {
    url: "permission-profile/",
  },
  permissionProfileById: {
    url: "permission-profile",
  },
  assignProfileUserList: {
    url: "assign-profiles-user-list",
  },
  staffEditAssignProfile: {
    url: "staff-edit-assign-profile",
  },
};
